import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { listGenerationJobs } from '@/services/templateSystemApi';
import { queryKeys } from '@/lib/queryKeys';
import EmptyState from '@/components/common/EmptyState';
import ContentApiErrorState from '@/components/common/ContentErrorState';
import PageLoading from '@/components/common/PageLoading';

export default function GenerationJobsPage() {
  const query = useQuery({
    queryKey: queryKeys.generationJobs.list,
    queryFn: () => listGenerationJobs(),
    retry: 1,
  });

  if (query.isLoading) {
    return <PageLoading message='生成记录加载中…' />;
  }

  if (query.isError) {
    return (
      <div className='max-w-[1080px] mx-auto px-6 py-12'>
        <ContentApiErrorState error={query.error} onRetry={() => void query.refetch()} />
      </div>
    );
  }

  const rows = query.data ?? [];

  return (
    <div className='max-w-[1080px] mx-auto px-6 py-12'>
      <h1
        className='font-semibold text-apple-near-black mb-2'
        style={{ fontSize: '2rem', lineHeight: 1.1, letterSpacing: '-0.02em' }}
      >
        生成历史
      </h1>
      <p className='text-apple-gray mb-8 text-[0.9375rem]'>查看已提交的模板生成任务和产物。</p>

      {rows.length === 0 ? (
        <EmptyState
          title='暂无生成记录'
          description='从模板库发起一次生成后会在这里展示。'
          action={
            <Link to='/templates' className='btn btn-primary'>
              去模板库
            </Link>
          }
        />
      ) : (
        <div className='bg-white rounded-2xl shadow-card-sm overflow-hidden'>
          <div className='overflow-x-auto'>
            <table className='min-w-full text-[0.875rem]'>
              <thead>
                <tr className='text-left border-b border-apple-border bg-apple-light-gray/60'>
                  <th className='px-4 py-3 font-medium'>模板</th>
                  <th className='px-4 py-3 font-medium'>Provider/Model</th>
                  <th className='px-4 py-3 font-medium'>状态</th>
                  <th className='px-4 py-3 font-medium'>创建时间</th>
                  <th className='px-4 py-3 font-medium'>操作</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((job) => (
                  <tr key={job.id} className='border-b border-apple-border/70'>
                    <td className='px-4 py-3'>
                      <p className='font-medium text-apple-near-black'>{job.template?.name ?? job.templateId}</p>
                      <p className='text-apple-gray text-[0.75rem]'>{job.template?.slug ?? ''}</p>
                    </td>
                    <td className='px-4 py-3 text-apple-gray'>
                      {(job.llmProvider?.name ?? 'mock')}/{job.llmModel?.modelId ?? 'mock-template-v1'}
                    </td>
                    <td className='px-4 py-3 text-apple-gray'>{job.status}</td>
                    <td className='px-4 py-3 text-apple-gray'>{new Date(job.createdAt).toLocaleString('zh-CN', { hour12: false })}</td>
                    <td className='px-4 py-3'>
                      <Link to={`/generation-jobs/${job.id}`} className='btn btn-secondary'>
                        查看结果
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
